import useEvents from 'lib/hooks/useEvents';
import srpTileTapEvent from 'lib/Tracking/Srp/SrpTIle/OpenTap';
import srpTileCtaHover from 'public/static/images/srp/SrpTileHover.svg';
import srpTileCtaDefault from 'public/static/images/srp/SrpTileDefault.svg';

interface SrpTileCtaProps {
  onClick: () => void;
  isMobile?: boolean;
}

const SrpTileCta = ({ onClick, isMobile = false }: SrpTileCtaProps): JSX.Element => {
  const logger = useEvents();
  return (
    <>
      <button
        data-testid="srp-tile-cta"
        className="srp-tile-cta"
        onClick={(e): void => {
          e.preventDefault();
          logger.log(srpTileTapEvent());
          onClick();
        }}
      >
        <img
          alt=""
          src={srpTileCtaDefault}
          onMouseOver={(e): void => {
            e.currentTarget.src = srpTileCtaHover;
          }}
          onMouseOut={(e): void => {
            e.currentTarget.src = srpTileCtaDefault;
          }}
          onFocus={(e): void => {
            e.currentTarget.src = srpTileCtaHover;
          }}
          onBlur={(e): void => {
            e.currentTarget.src = srpTileCtaDefault;
          }}
          className="srp-tile-cta-image"
        />
      </button>
      <style jsx>{`
        .srp-tile-cta {
          all: unset;
          display: flex;
          position: ${isMobile ? 'absolute' : 'relative'};
          bottom: ${isMobile ? '-16px' : ''};
          top: ${isMobile ? '' : '-12px'};
          right: ${isMobile ? '50%' : '-8px'};
          z-index: 100;
          transform: ${isMobile ? 'rotate(90deg)' : ''};
        }

        .srp-tile-cta-image {
          height: ${isMobile ? '33px' : '174px'};
          width: 16px;
        }
      `}</style>
    </>
  );
};

export default SrpTileCta;
